import { supabase, supabaseEnabled } from './supabase'
import { EVENT } from '../constants/event'

// Idempotently records the current EVENT in the `events` catalog so Supabase
// retains a row for every event the app has ever pointed at (Phoenix, LA, …).
// Cheap to call on app load.
export async function ensureCurrentEvent(): Promise<void> {
  if (!supabaseEnabled || !supabase) return
  const { error } = await supabase.from('events').upsert(
    {
      slug: EVENT.slug,
      name: EVENT.name,
      date_range: EVENT.dateRange,
    },
    { onConflict: 'slug', ignoreDuplicates: true },
  )
  if (error) console.warn('[events] catalog upsert failed', error)
}
